module.exports = {
  messages: {
    Active: 'Aktivní',
    Add: 'Přidat',
    'Add Beer Selection': 'Přidat výbět piv',
    'Add Beer Servings': 'Přidat návrh servírování piva',
    'Add New dish': 'Přidat nové jídlo',
    'Add New item': 'Přidat novou položku',
    'Add Picture': 'Přidat obrázek',
    'Add QR code': 'Přidat QR kód',
    'Add Star Of The Crafters': 'Přidat Hvězdu sládků - ČB',
    'Add Colored Star Of The Crafters': 'Přidat Hvězdu sládků - barevná',
    'Add category or element': 'Přidat kategorii nebo prvek',
    'Add dish': 'Přidat jídlo',
    'Add item': 'Přidat položku',
    'Add meal': 'Přidat jídlo',
    'Add new menu': 'Přidat nové menu',
    'Add other': 'Přidat ostatní',
    'Add soup': 'Přidat polévku',
    'After creating a category, you can add dishes.':
      'Po vytvoření kategorie můžete přidávat jídla.',
    'Alcohol Content': 'Obsah alkoholu',
    All: 'Všechny',
    'All languages': 'Všechny jazyky',
    Allergens: 'Alergeny',
    Amount: 'Množství',
    'Are you sure you want to delete this daily menu?':
      'Jste si jisti, že chcete toto denní menu odstranit?',
    'Are you sure you want to delete this menu?':
      'Jste si jisti, že chcete toto menu odstranit?',
    'Available only for A4 size': 'Dostupné jen pro formát A4',
    'Back to Daily Menu': 'Zpět',
    'Back to Food Menu': 'Zpět',
    'Beer Selection': 'Výběr piv',
    'Beer Type': 'Pivní styl',
    'Beer servings': 'Kvalita piva',
    Bottom: 'Dole',
    'Brand elements': 'Brandové prvky',
    "Can't upload image": 'Obrázek nelze nahrát',
    Cancel: 'Zrušit',
    Categories: 'Kategorie',
    'Click to select a date': 'Vyberte datum',
    Close: 'Zavřít',
    Color: 'Barva',
    Continue: 'Pokračovat',
    'Copy menu': 'Kopírovat menu',
    'Country Of Origin': 'Země původu',
    'Create Text Block': 'Vytvořit textové pole',
    Currency: 'Měna',
    'Daily Menu': 'Denní menu',
    'Daily menu': 'Denní menu',
    Data: 'Data',
    'Data & Elements': 'Data & Prvky',
    Delete: 'Odstranit',
    'Delete menu': 'Odstranit menu',
    'Delete page break': 'Odstranit rozdělovník stránky',
    Description: 'Popis',
    'Description (Optional)': 'Popis (Volitelný)',
    Desserts: 'Dezerty',
    Designs: 'Návrhy',
    Displays: 'Zobrazení',
    'Double Image Block': 'Blok dvou obrázků',
    Duplicate: 'Duplikovat',
    'Duplicate menu': 'Duplikovat menu',
    Edit: 'Upravit',
    'Edit Beer Servings': 'Upravit pivní servírování',
    'Edit Picture': 'Upravit obrázek',
    'Edit QR code': 'Upravit QR kód',
    'Edit Star Of The Crafters': 'Upravit Hvězdu sládků - ČB',
    'Edit Colored Star Of The Crafters': 'Upravit Hvězdu sládků - barevná',
    'Edit Text Block': 'Upravit textové pole',
    'Edit dish': 'Upravit jídlo',
    Elements: 'Prvky',
    Email: 'Email',
    'Error!': 'Chyba!',
    Export: 'Export',
    'Export XML': 'Exportovat jako XML',
    'Export PDF': 'Exportovat jako PDF',
    'Export as JPG': 'Exportovat jako JPG',
    Fermentation: 'Druh kvašení',
    'Fill in your contact information and we will reach back to you:':
      'Fill in your contact information and we will reach back to you:',
    'Food cards & Specials': 'Stálé menu & speciální nabídky',
    'Food Combinations': 'Párování s jídlem',
    'Food image': 'Obrázek jídla',
    'Generate QR code': 'Generovat QR kód',
    Grid: 'Mřížka',
    'Hover over the tab area to see options for adding categories and elements.':
      'Pro zobrazení možností přidání kategorií a prvků přejeďte myší po zobrazené oblasti.',
    'Hviezda sladkov': 'Hvězda sládků - ČB',
    'Farebna hviezda sladkov': 'Hvězda sládků - barevná',
    Inline: 'Mezi obsahem',
    'Jsme hrdí držitelé hvězdy sládků 2020':
      'Jsme hrdí držitelé hvězdy sládků 2020',
    Language: 'Jazyk',
    List: 'Seznam',
    'Log in': 'Přihlásit',
    Logo: 'Logo',
    'Logo (Not available)': 'Logo (není k dispozici)',
    Logout: 'Odhlásit',
    Meals: 'Jídla',
    Menu: 'Menu',
    'Move Block': 'Přesunout sekci',
    'Move Dish': 'Přesunout jídlo',
    'Move Dish position': 'Přesunout pozici jídla',
    'Move after block': 'Přesunout za sekci',
    'Move after dish': 'Přesunout za jídlo',
    'Move block position': 'Přesunout pozici sekce',
    'Move to beginning': 'Přesunout na začátek',
    Name: 'Název',
    'Name of Restaurant': 'Název restaurace',
    'Name of category': 'Název kategorie',
    'category/element': 'kategorii/prvek',
    Next: 'Další',
    'No daily menus were found. Please try to change filters.':
      'Nebylo nalezeno žádné denní menu. Zkuste prosím změnit filtry.',
    'No menus were found. Please try to change filters.':
      'Źádné menu nebylo nalezeno. Zkuste změnit vyhledávání.',
    'Ocenění za nejlepší peči o čepované pivo':
      'Ocenění za nejlepší peči o čepované pivo',
    'One column': 'Jeden sloupec',
    'One column with image': 'Jeden sloupec s obrázkem',
    'Order print': 'Objednat tisk',
    Other: 'Jiné',
    Others: 'Ostatní',
    'Page break': 'Rozdělovník strany',
    Phone: 'Telefonní číslo',
    Picture: 'Obrázek',
    'Please continue by logging in': 'Přihlaste se, prosím',
    Position: 'Umístění',
    Preview: 'Náhled',
    Price: 'Cena',
    'Price with soup': 'Cena s polévkou',
    'Price with meal': 'Cena s jídlem',
    'Price with soup and meal': 'Cena s polévkou a hlavním jídlem',
    Primary: 'Hlavní',
    'Secondary Primary': 'Hlavní',
    Print: 'Tisk',
    'QR code': 'QR kód',
    'Recommend a drink': 'Doporučit nápoj',
    Remove: 'Odebrat',
    'Remove category': 'Odebrat kategorii',
    'Remove dish': 'Odebrat jídlo',
    'Required field': 'Požadované pole',
    Save: 'Uložit',
    'Select allergens': 'Vybrat alergeny',
    'Serving Temperature': 'Teplota servírování',
    'Set to active': 'Nastavit jako aktivní',
    'Set to inactive': 'Nastavit jako neaktivní',
    Settings: 'Nastavení',
    Share: 'Sdílet',
    'Share on FB': 'Sdilet na FB',
    'Copy menu link': 'Kopírovat link na menu',
    'Show Allergens': 'Zobrazit alergeny',
    'Show Title Page': 'Zobrazit úvodní stranu',
    'Show info': 'Zobrazit informace',
    'Show name of Restaurant': 'Zobrazit jméno restaurace',
    'Show portion size': 'Zobrazit velikost porce',
    'Show text': 'Zobrazit text',
    'Show weight / bulk / pieces': 'Zobrazit gramáž / objem / kusy',
    Size: 'Formát',
    'Secondary Size': 'Formát',
    'size in cl': 'velikost v cl',
    'size in ml': 'velikost v ml',
    Soup: 'Polévka',
    'Soup can be orderer separately': 'Polévku lze objednat zvlášť',
    'Soup priced in main dish': 'Polévka je zahrnuta v ceně hlavního jídla',
    Soups: 'Polévky',
    Submit: 'Uložit',
    Taste: 'Chuťový profil',
    Templates: 'Šablony',
    'Text block': 'Textové pole',
    'Tips & Tricks': 'Nápověda',
    Title: 'Název',
    'Two columns': 'Dva sloupce',
    'Two columns with image': 'Dva sloupce s obrázkem',
    'Type or choose category': 'Napsat nebo vybrat kategorii',
    'Type or choose dish': 'Napsat nebo vybrat jídlo',
    'URL address': 'URL adresa',
    Untitled: 'Bez názvu',
    'Upload image': 'Nahrát obrázek',
    'We do not offer anything for this day': 'V tento den nevaříme',
    'We do not offer:': 'Nenabízíme:',
    'Weight / bulk / pcs': 'Váha / objem / kusy',
    'Weight / bulk / pieces': 'Váha / objem / kusy',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Touto změnou můžete přijít o některá nastavení menu. Přejete si pokračovat?',
    'Známky kvalitně načepovaného piva': 'Známky kvalitně načepovaného piva',
    'Upload image': 'Nahrát obrázek',
    'Weight / bulk / pcs': 'Váha / objem / kusy',
    add: 'přidat',
    description: 'popis',
    item: 'položka',
    language: 'jazyk',
    languange: 'jazyk',
    logo: 'logo',
    'remove page': 'odstranit stránku',
    'No menus were found. Please try to change filters.':
      'Nebylo nalezeno žádné menu. Zkuste prosím změnit filtry.',
    Language: 'Jazyk',
    units: 'jednotky',
    'Secondary Menu': 'Menu',
    'Secondary Other': 'Ostatní',
    'Logo (Not available)': 'Logo (Není k dispozici)',
    "Can't upload image": 'Nelze nahrát obrázek',
    'Description not available': 'Popis není k dispozici',
    'Edit Beer Selection': 'Upravit výběr piva',
    'Add Beer Selection': 'Přidat výběr piv',
    'Title is required': 'Název je povinný',
    'Select beers': 'Vybrat piva',
    'Mandatory field': 'Povinné pole',
    Image: 'Obrázek',
    'not available': 'není dostupný',
    'Copied successfully!': 'Úspěšně zkopírováno!',
    'Error copied!': 'Chyba při kopírování!',
    'Separate price for each item': 'Samostatná cena za každou položku',
    'Soup price is included in menu': 'Cena polévky je zahrnuta v ceně menu',
    'Different price for whole menu': 'Různá cena za celé menu',
    'Responsibility Message': 'Zpráva o zodpovědnosti',
    'ID:': 'ID',
    'Please complete the first 2 steps': 'Dokončete prosím první 2 kroky',
    'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.':
      'Generování obrázku probíhá. Prosím, čekejte. Po dokončení stahování se vraťte na seznam denních menu.',
    'Are you sure you want to delete this category?':
      'Jste si jisti, že chcete tuto kategorii odstranit?',
    Yes: 'Ano',
    No: 'Ne',
    'Delete item': 'Odstranit položku',
    'Edit element': 'Upravit prvek',
    'Write a name': 'Napište název',
    'Create category': 'Vytvořit kategorii',
    'Edit category': 'Upravit kategorii',
    'Delete category': 'Odstranit kategorii',
    'Choose a category': 'Vyberte kategorii',
    Custom: 'Vlastní',
    'Add item': 'Přidat položku',
    'Add category': 'Přidat kategorii',
    'This category already exists.': 'Tato kategorie již existuje.',
    'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.':
      'Něco se pokazilo, pravděpodobně váš soubor přesahuje povolenou velikost zpracování po odeslání 10Mb. Zkuste to znovu s menším souborem.',
    'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.':
      'Nahrávaný soubor přesahuje maximální povolenou velikost 10MB. Nahrajte prosím menší soubor.',
    Warning: 'Varování',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Touto změnou můžete přijít o některá nastavení menu. Přejete si pokračovat?',
    'Bottom description': 'Popis pod menu',
    'Logo size': 'Velikost loga',
    Small: 'Malé',
    Medium: 'Střední',
    Large: 'Velké',

    Warning: 'Upozornění',
    'Before sending the menu to the printer, please carefully check the content and graphics of the menu in the PDF preview! The printing company is not responsible for the content of the data sent in the order.':
      '„Před odesláním lístku do tiskárny si prosím pečlivě zkontrolujte obsah i vzhled lístku v PDF náhledu! Za vzhled i obsah dat odeslaných do tiskárny je vždy zodpovědný objednatel.“',
    'Print Parameters': 'Parametry tisku',
    Name: 'Název',
    'Number of Menu Pages': 'Počet stran lístku',
    'Menu Format': 'Formát lístku',
    'Paper Color': 'Barva papíru',
    'Type of Binding': 'Druh vazby',
    'Paper Finish': 'Úprava povrchu',
    'Number of Copies': 'Počet kopií',
    'Price Excluding VAT:': 'Cena bez DPH:',
    'Shipping Excluding VAT:': 'Doprava bez DPH:',
    'Total Including VAT:': 'Celkem včetně DPH:',
    'The name, number of pages, and format can only be modified in the editor menu.':
      'Název, počet stran a formát lze upravovat pouze v menu editoru.',
    'Menu without binding or with Twin binding are always made double-sided, Wire Stitched binding uses the entire four sides...':
      'Lístky bez vazby nebo s vazbou Twin se zhotovují vždy na dvojstrany, vazba Šitá drátem používá celé čtyřstrany. Pokud váš lístek nemá počet stránek dělitelný čtyřmi, není možné zvolit druh vazby Šitá drátem. U lístku do velikosti 4 stran také není možné volit vazbu a lístek bude vždy zhotoven bez vazby.',
    'Billing Address': 'Fakturační adresa',
    'First and Last Name': 'Jméno a příjmení (Název firmy)',
    'Street/No.': 'Ulice/čp',
    City: 'Město',
    'Postal Code': 'PSČ',
    Country: 'Země',
    'Company ID': 'IČO',
    Phone: 'Telefon',
    'E-mail': 'E-mail',
    'Different Shipping Address': 'Zásilku doručit na jinou adresu',
    'Order Summary': 'Rekapitulace objednávky',
    'Discount Code': 'Slevový kód',
    'Terms and Conditions': 'Obchodní podmínky',
    'The customer acknowledges that the company is not responsible for the content of data provided within the order.':
      'Zákazník bere na vědomí, že společnost nenese odpovědnost za obsah dat poskytnutých v rámci zakázky.',
    'The customer agrees that the order will be sent on delivery.':
      'Zákazník souhlasí s tím, že objednávka bude zaslána na dobírku.',
    'The customer confirms the order of services and agrees that their production should be started immediately.':
      'Zákazník potvrzuje, že závazně objednává výrobky či služby, a souhlasí s tím, aby byla neprodleně zahájena jejich výroba.',
    'I agree with the terms and conditions':
      'Souhlasím s obchodními podmínkami',
    Price: 'Cena',
    'Submit Order': 'Odeslat objednávku',
    'We have received your order!': 'Přijali jsme vaši objednávku!',
    'Required field': 'Toto pole je povinné',
    'We have received your order and processing it. Confirmation of your order has been sent to the email provided in the order.':
      'Vaši objednávku jsme přijali ke zpracování. Potvrzení vaši objednávky jsme zaslali na e-mail uvedený v objednávce.',
    'Back to Editor': 'Back to Editor',
    'Note for the printer': 'Poznámka pro tiskárnu',
    'Without (2 pages)': 'Bez vazby (2 strany)',
    'Fold (4 pages)': 'Lom (4 strany)',
    Ring: 'Kroužková vazba',
    'Wire Stitched': 'Šité drátem',
    'Without Print Finish': 'Bez úpravy',
    'Matte Print Finish': 'Matná',
    'Shiny Print Finish': 'Lesklá',
    'White 250g': 'Bílá',
    'Cream 250g': 'Krémová',
  },
}
